import {
  NodeExtension,
  extension,
  NodeExtensionSpec,
  command,
  CommandFunction,
  ExtensionTag,
} from 'remirror'
import { mathPlugin } from '@benrbray/prosemirror-math'
import { NodeSelection, Plugin } from '@remirror/pm/state'

import '@benrbray/prosemirror-math/style/math.css'
import 'katex/dist/katex.min.css'
import { defaultInlineMathParseRules } from './math-parse-rules'

@extension({
  defaultOptions: {
    disableExtraAttributes: true,
  },
})
export class MathInlineExtension extends NodeExtension {
  get name() {
    return `math_inline`
  }

  createTags() {
    return [ExtensionTag.InlineNode]
  }

  createNodeSpec(): NodeExtensionSpec {
    return {
      group: 'inline math',
      content: 'text*',
      inline: true,
      atom: true,
      parseDOM: [
        {
          tag: 'math-inline',
        },
        ...defaultInlineMathParseRules,
      ],
      toDOM: () => ['math-inline', { class: 'math-node' }, 0],
    }
  }

  createExternalPlugins(): Plugin[] {
    return [mathPlugin]
  }

  @command()
  insertMathInline(): CommandFunction {
    // modified `insertMathCmd` from `@benrbray/prosemirror-math` to make it work with remirror commands
    return ({ tr, dispatch, state }) => {
      const { $from } = state.selection
      const index = $from.index()
      if (!$from.parent.canReplaceWith(index, index, this.type)) {
        return false
      }
      if (dispatch) {
        const mathNode = this.type.create({})
        const transaction = tr
          .replaceSelectionWith(mathNode)
          .setSelection(NodeSelection.create(tr.doc, $from.pos))
        dispatch(transaction)
      }
      return true
    }
  }
}
